<template>
    <a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true"
             :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="id" name="id">
                    <a-input v-model:value="form.id"/>
                </a-form-item>
            </div>
            <a-row :gutter="[24, 8]">

                <a-col :span="12">
                    <a-form-item label="单位名称" name="unitName">
                        <a-input v-model:value="form.unitName" placeholder="请输入单位名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="统一社会信用代码" name="licence">
                        <a-input disabled v-model:value="form.licence" placeholder="请输入统一社会信用代码"/>
                    </a-form-item>
                </a-col>
<!--                <a-col :span="12">
                    <a-form-item label="联系人" name="linkPerson">
                        <a-input v-model:value="form.linkPerson" placeholder="请输入联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="linkWay">
                        <a-input v-model:value="form.linkWay" placeholder="请输入联系电话"/>
                    </a-form-item>
                </a-col>-->


                <a-col :span="12">
                    <a-form-item label="法人姓名" name="legalPersonName">
                        <a-input v-model:value="form.legalPersonName" placeholder="请输入法人姓名"/>
                    </a-form-item>
                </a-col>

              <a-col :span="12">
                <a-form-item label="法人手机号" name="legalPersonPhone">
                  <a-input disabled v-model:value="form.legalPersonPhone" placeholder="请输入法人手机号"/>
                </a-form-item>
              </a-col>
<!--                <a-col :span="12">
                    <a-form-item label="法人身份证号" name="legalPersonCard">
                        <a-input v-model:value="form.legalPersonCard" placeholder="请输入法人身份证号"/>
                    </a-form-item>
                </a-col>-->
              <a-col :span="24">
                <a-form-item label="单位地址" name="address">
                  <a-input v-model:value="form.address" placeholder="请输入地址"/>
                </a-form-item>
              </a-col>
                <a-col :span="24">
                  <a-form-item label="法人身份证(PDF)" name="legalPersonCard">
                    <FileUpload v-model:value="form.legalPersonCard" :multiple="false" :size="50" :count="1"></FileUpload>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="法人证书/营业执照(PDF)" name="legalPersonCredentials">
                        <FileUpload v-model:value="form.legalPersonCredentials" :multiple="false" :size="50" :count="1"></FileUpload>
                    </a-form-item>
                </a-col>

            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {govInstitution} from "@/api/projectReviewService";
import FileUpload from "@/components/form/upload/FileUpload";

export default {
    name: "UserModal",
    components: {FileUpload},
    mixins: [formMixin],
    data() {
        return {
            form: {
                id: null,
            },
            rules: {
                id:[],
                licence:[dataCheck.required({})],
                unitName: [dataCheck.required({})],
                linkPerson: [dataCheck.required({})],
                linkWay: [dataCheck.required({})],
                address:[dataCheck.required({})],
                legalPersonName:[dataCheck.required({})],
                legalPersonCard:[dataCheck.required({})],
                legalPersonPhone:[dataCheck.mobile_phone],
                legalPersonCredentials:[dataCheck.required({})],
            },
            submitUrl: govInstitution.save
        }
    },
}
</script>
<style scoped lang="less"></style>
